//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";

export interface ObjectRowProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  meta?: ReactNode;
  /** Two or three at most — only what lets you choose between rows. */
  attributes?: ReactNode[];
  status?: ReactNode;
  /** One action, naming the verb: "Monteure zuordnen", not "Bearbeiten". */
  action?: ReactNode;
  leading?: ReactNode;
  selected?: boolean;
}

/** List representation of an object: identity, key attributes, status, action. */
export function ObjectRow({
  title,
  meta,
  attributes = [],
  status,
  action,
  leading,
  selected,
  onClick,
  className = "",
  ...rest
}: ObjectRowProps) {
  return (
    <div
      className={`bui-obj-row ${className}`}
      data-selected={selected || undefined}
      data-interactive={onClick ? "true" : undefined}
      onClick={onClick}
      {...rest}
    >
      {leading}
      <div className="bui-obj-row__main">
        {title && (
          <span
            className="bui-obj-row__title"
            title={typeof title === "string" ? title : undefined}
          >
            {title}
          </span>
        )}
        {meta && (
          <span
            className="bui-obj-row__meta"
            title={typeof meta === "string" ? meta : undefined}
          >
            {meta}
          </span>
        )}
      </div>
      {attributes.length > 0 && <div className="bui-obj-row__attrs">{attributes}</div>}
      {status && <div className="bui-obj-row__status">{status}</div>}
      {action && <div className="bui-obj-row__action">{action}</div>}
    </div>
  );
}
